/** Save-then-maybe-sign-off orchestration used by both weighing pages.
 *  A null payload means nothing changed in edit mode (sign-off can still
 *  proceed on the known id). A failed sign-off is swallowed: the draft is
 *  saved either way and lands on the list with its Sign off button — the
 *  action hook already toasted the error.
 *  Resolves with the weighing id (created or existing) so the caller can
 *  attach follow-up work — e.g. flushing captured photos to the upload tray. */
export async function saveWeighingThenMaybeSignOff<
  TId extends string,
  TCreate,
  TUpdate,
>(args: {
  payload: TCreate | TUpdate | null;
  withSignOff: boolean;
  existingId: TId | undefined;
  update: (id: TId, data: TUpdate) => Promise<void>;
  create: (data: TCreate) => Promise<{ id: string }>;
  signOffAsync: (id: TId) => Promise<void>;
}): Promise<TId | undefined> {
  let id = args.existingId;
  if (args.payload) {
    if (args.existingId) {
      await args.update(args.existingId, args.payload as TUpdate);
    } else {
      id = (await args.create(args.payload as TCreate)).id as TId;
    }
  }
  if (args.withSignOff && id) {
    try {
      await args.signOffAsync(id);
    } catch {
      /* fall through — caller navigates to the list either way */
    }
  }
  return id;
}
